export function processData(selected, history, index = 0) {
    const data = []
    const labels = []
    let pointStyle = 'circle'
    let borderDash = [0, 0]
    function color() {
        if(index > 0) {
            return selected === 'contagios' && '#492062'  ||
                selected === 'fallecidos' && '#492062' ||
                selected === 'recuperados' && '#492062'
        } else {
            return selected === 'contagios' && '#FFBA4E' ||
                selected === 'fallecidos' && '#FFBA4E' ||
                selected === 'recuperados' && '#FFBA4E'
        }

    }

    if (selected === 'contagios') {
        borderDash = []
    } else if (selected === 'fallecidos') {
        borderDash = [10, 5]
    } else if (selected === 'recuperados') {
        borderDash = [2, 2]
    }

    for (let fecha in history) {
        data.push(history[fecha][selected])
        labels.push(fecha.slice(8, 10) + '.' + fecha.slice(5, 7))
    }

    if (index > 0) {
        if (selected === 'contagios') {
            borderDash = []
        } else if (selected === 'fallecidos') {
            borderDash = [10, 10]
        } else if (selected === 'recuperados') {
            borderDash = [1, 1]
        }
        // pointStyle = 'triangle'
    }

    return { labels, data, pointStyle, borderDash, borderColor: color }
}

export function formatNumber(number) {
    var parts = (+number).toFixed(2).split('.');
    var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (+parts[1] ? ',' + parts[1] : '');
    return num;
}

export function disableDates (value) {
    let date = new Date(value)
    var today = new Date()
    today.setHours(0,0,0,0)
    if (date > today) return true
    if (date < new Date('2020-03-02')) return true
    return false
}
